import {Component, Inject, OnInit} from '@angular/core';
import {Broadcast} from "../../model/broadcast/broadcast";
import {Observable} from "rxjs";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {map, shareReplay} from "rxjs/operators";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {AsyncPipe} from "@angular/common";
import {StatusComponent} from "../../broadcast-layer-module/broadcast-layer/status/status.component";

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        AsyncPipe,
        StatusComponent
    ]
})
export class ConfirmDialogComponent implements OnInit {

  isMobile$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public broadcast: Broadcast,
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close('confirmed');
  }
}
